import { render } from "./HomeWarning.vue?vue&type=template&id=76032853&scoped=true"
import script from "./HomeWarning.vue?vue&type=script&lang=js"
export * from "./HomeWarning.vue?vue&type=script&lang=js"

import "./HomeWarning.vue?vue&type=style&index=0&id=76032853&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76032853"]])

export default __exports__